'use strict';

angular.module('TurneroApp').component('coAtencionEnCurso', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        '$scope',
		  'TurneroAppConstant',
        function ($scope, TurneroAppConstant) {
            var ctrl = this;
            
            ctrl.mostrarFiltro = true;
            ctrl.atencionEnCursoConsulta = true;
            ctrl.turnosConsulta = true;
            ctrl.turnoDetalles = false;
            ctrl.btnCancelar = false;
            ctrl.CancelarTurnos = {};
            ctrl.motivos_cancelacion = {};
            ctrl.dateHoy = new Date;
            ctrl.permisos = TurneroAppConstant.Permisos;

            //$scope.$on('verDetalleTurno_bool', function (event, data) {
            //    // you could inspect the data to see if what you care about changed, or just update your own scope
            //    if (data) { ctrl.turnosConsulta = false; } else { ctrl.turnosConsulta = true; };
            //    ctrl.turnoDetalles = data;
            //});
        }],
    template: require('./atencionEnCurso.html')
});



// WEBPACK FOOTER //
// ./app/components/supervision/atencionEnCursoComponent.js